import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctors-next-radio-button',
  templateUrl: './doctors-next-radio-button.component.html',
  styleUrls: [
    './doctors-next-radio-button.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextRadioButtonComponent implements OnInit {
  @Input()
  value: string = '';
  @Input()
  label: string = '';

  @Input()
  checked: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  get classes() {
    if (this.checked) {
      return 'checked';
    }
    return 'checkmark';
  }
}
